import {
  patchSalesOrderV1Data,
  getSalesOrderV1Data,
} from 'services/salesOrderV1';

export async function patchSalesOrders({ event }) {
  let response = '';
  let errorMessage = '';  
  try {
    response = await patchSalesOrderV1Data({
      data: {
        targetSalesOrder: event.targetSalesOrder,
        targetItemNumber: event.targetItemNumber,
        asn: event.asn,
        targetLineStatus: event.targetLineStatus,
        targetShippedQuantity: event.targetShippedQuantity,
        processingStatus: event.processingStatus,
        closureMessage: event.closureMessage,
        fullName: event.fullName,
        userId: event.userId,
      },
      url: `/salesorders/${event.salesOrderId}/salesOrderLine/${event.salesOrderLineId}`,
      withAuth: true,
    });
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}

export async function getSalesOrders({ reqParams = {} }) {
  let response = '';
  let errorMessage = '';
  try {
    response = await getSalesOrderV1Data({
      apiConfig: {
        params: reqParams,
      },
      url: '/salesorders',
      withAuth: true,
    })
  } catch (error) {
    errorMessage = error.message;
  }
  return { response, errorMessage };
}
